// Model.js
// -----------------------
// @module Case
define('BRListrak.SS2Model', ['Backbone', 'Utils'], function (Backbone, Utils) {
	'use strict';

	// @class Case.Fields.Model @extends Backbone.Model
	return Backbone.Model.extend({
		//@property {String} urlRoot
		urlRoot: Utils.getAbsoluteUrl(
			getExtensionAssetsPath('Modules/BRListrak/SuiteScript2/BRListrak.Service.ss'),
			true
		)
	});
});
